import type { TooltipProps } from '@mui/material';
import { Tooltip } from '@mui/material';
import classNames from 'classnames';

export const HelpIcon = ({
  title,
  alwaysVisible = false,
  tooltipProps,
  className,
}: {
  title: TooltipProps['title'];
  alwaysVisible?: boolean;
  tooltipProps?: Omit<TooltipProps, 'title' | 'children'>;
  className?: string;
}) => {
  return (
    <Tooltip title={title} {...tooltipProps}>
      <i
        className={classNames(
          'material-symbols-help-outline-rounded h-[20px] w-[20px] p-[2px] leading-none',
          {
            'opacity-0 group-hover/help:opacity-100 transition-opacity':
              !alwaysVisible,
          },
          className
        )}
      />
    </Tooltip>
  );
};
